import { render, staticRenderFns } from "./FormViewer.vue?vue&type=template&id=350fb0d4&scoped=true&"
import script from "./FormViewer.vue?vue&type=script&lang=ts&"
export * from "./FormViewer.vue?vue&type=script&lang=ts&"
import style0 from "./FormViewer.vue?vue&type=style&index=0&id=350fb0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350fb0d4",
  null
  
)

export default component.exports